/**
 * 营运中心--》签收登记
 */

export default {
  // 签收单 / 其他费用
  delivery_receipt_form_other_expenses: ['96256', '88569', '80112', '96165'] // 202510201421283907575 支持输入2位小数
}
